module.exports = __webpack_public_path__ + "img/720.8a2bbf64.svg";